import type { FC } from 'react';

import { cx } from '@emotion/css';
import { Text } from '@livechat/design-system-react-components';
import { useSelector } from 'react-redux';

import { getIsCopilotDetailsOpened } from 'store/views/copilot/selectors';

import { AboutCopilotAccordion } from './AboutCopilotAccordion';
import { FeedbackBanner } from './FeedbackBanner';
import { ReplySuggestionsAccordion } from './ReplySuggestionsAccordion';

import * as styles from './styles';

export const CopilotDetails: FC = () => {
  const isDetailsOpened = useSelector(getIsCopilotDetailsOpened);

  return (
    <div className={cx(styles.wrapper, { [styles.openedDetailsWrapper]: isDetailsOpened })}>
      <div className={styles.detailsWrapper}>
        <AboutCopilotAccordion />
        <FeedbackBanner />
        <ReplySuggestionsAccordion />
        <Text className={styles.detailsCopilotInfo}>
          *Copilot can make mistakes. Consider checking important information.
        </Text>
      </div>
    </div>
  );
};
